var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
function addLimeSpotAccessibility() {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          const element = node;
          const prevButtons = element.querySelectorAll ? element.querySelectorAll(".ls-nav-button.ls-prev-button") : [];
          const nextButtons = element.querySelectorAll ? element.querySelectorAll(".ls-nav-button.ls-next-button") : [];
          prevButtons.forEach((btn) => {
            if (!btn.getAttribute("aria-label")) {
              btn.setAttribute("aria-label", "Previous product");
              btn.setAttribute("role", "button");
            }
          });
          nextButtons.forEach((btn) => {
            if (!btn.getAttribute("aria-label")) {
              btn.setAttribute("aria-label", "Next product");
              btn.setAttribute("role", "button");
            }
          });
          if (element.classList && element.classList.contains("ls-nav-button")) {
            if (element.classList.contains("ls-prev-button") && !element.getAttribute("aria-label")) {
              element.setAttribute("aria-label", "Previous product");
              element.setAttribute("role", "button");
            } else if (element.classList.contains("ls-next-button") && !element.getAttribute("aria-label")) {
              element.setAttribute("aria-label", "Next product");
              element.setAttribute("role", "button");
            }
          }
        }
      });
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  setTimeout(() => {
    const existingPrevButtons = document.querySelectorAll(".ls-nav-button.ls-prev-button");
    const existingNextButtons = document.querySelectorAll(".ls-nav-button.ls-next-button");
    existingPrevButtons.forEach((btn) => {
      if (!btn.getAttribute("aria-label")) {
        btn.setAttribute("aria-label", "Previous product");
        btn.setAttribute("role", "button");
      }
    });
    existingNextButtons.forEach((btn) => {
      if (!btn.getAttribute("aria-label")) {
        btn.setAttribute("aria-label", "Next product");
        btn.setAttribute("role", "button");
      }
    });
  }, 1e3);
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", addLimeSpotAccessibility);
} else {
  addLimeSpotAccessibility();
}
function initDiscountNinjaDynamicPrice() {
  const announcementBar = document.getElementById("announcement-bar");
  const targetOffset = announcementBar ? announcementBar.offsetTop : 0;
  function toggleBodyClass() {
    const scrollPosition = window.scrollY;
    if (scrollPosition > targetOffset) {
      document.body.classList.add("scrolled");
    } else {
      document.body.classList.remove("scrolled");
    }
  }
  toggleBodyClass();
  window.addEventListener("scroll", function() {
    const stickyBarWrapper = document.getElementById(
      "limoniapps-discountninja-stickybar-wrapper"
    );
    const elementHeight = stickyBarWrapper ? stickyBarWrapper.offsetHeight : 0;
    document.documentElement.style.setProperty(
      "--limo-height",
      elementHeight + "px"
    );
    toggleBodyClass();
  });
}
function intervalFunction() {
  document.dispatchEvent(new CustomEvent("la:dn:collection:updated"));
}
function startDiscountNinjaInterval() {
  const intervalId = setInterval(intervalFunction, 1e3);
  setTimeout(() => {
    clearInterval(intervalId);
  }, 3e4);
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    initDiscountNinjaDynamicPrice();
    startDiscountNinjaInterval();
  });
} else {
  initDiscountNinjaDynamicPrice();
  startDiscountNinjaInterval();
}
class ChatButtonManagerImpl {
  constructor() {
    __publicField(this, "backToTopButton", null);
    __publicField(this, "ringButton", null);
    __publicField(this, "isChatOpen", false);
    __publicField(this, "observer", null);
    __publicField(this, "intervalId", null);
    __publicField(this, "lastChatState", false);
  }
  init() {
    document.addEventListener("DOMContentLoaded", () => {
      this.setupButtons();
    });
  }
  setupButtons() {
    this.backToTopButton = document.getElementById("back-to-top-button");
    this.ringButton = document.getElementById("ring-button");
    if (!this.backToTopButton || !this.ringButton) {
      return;
    }
    document.documentElement.style.setProperty("--chatlio-offset", "0px");
    this.addStyles();
    this.setupScrollListener();
    this.setupChatMonitoring();
    setTimeout(() => {
      this.updateChatState();
      this.lastChatState = this.checkChatStatus();
    }, 1e3);
  }
  addStyles() {
    const style = document.createElement("style");
    style.textContent = `
      #back-to-top-button {
        bottom: calc(56px + var(--chatlio-offset)) !important;
        transition: bottom 0.3s ease-in-out, opacity 0.3s ease-in-out, transform 0.3s ease-in-out !important;
      }
      
      #ring-button {
        bottom: calc(56px + var(--chatlio-offset)) !important;
        transition: bottom 0.3s ease-in-out, opacity 0.3s ease-in-out, transform 0.3s ease-in-out !important;
      }
      
      @media screen and (max-width: 480px) {
        #ring-button {
          bottom: calc(80px + var(--chatlio-offset)) !important;
        }
      }
      
      /* When back-to-top is visible, ring button should be higher */
      #ring-button.back-to-top-visible {
        bottom: calc(145px + var(--chatlio-offset)) !important;
      }
    `;
    document.head.appendChild(style);
  }
  setupScrollListener() {
    const updateRingButtonPosition = () => {
      if (!this.ringButton) return;
      if (window.pageYOffset > window.innerHeight) {
        this.ringButton.classList.add("back-to-top-visible");
      } else {
        this.ringButton.classList.remove("back-to-top-visible");
      }
    };
    window.addEventListener("scroll", updateRingButtonPosition);
    updateRingButtonPosition();
  }
  moveButtonsUp() {
    if (!this.isChatOpen) {
      this.isChatOpen = true;
      document.documentElement.style.setProperty("--chatlio-offset", "560px");
    }
  }
  resetButtonsPosition() {
    if (this.isChatOpen) {
      this.isChatOpen = false;
      document.documentElement.style.setProperty("--chatlio-offset", "0px");
    }
  }
  checkChatStatus() {
    const openChatSelectors = [
      // Chat containers that are visible
      '.chatlio-chat-container[style*="display: block"]',
      '.chatlio-chat-container[style*="display: flex"]',
      '.chatlio-chat-window[style*="display: block"]',
      '.chatlio-chat-window[style*="display: flex"]',
      // Widgets with expanded class
      ".chatlio-widget.chatlio-expanded",
      ".chatlio-widget.chatlio-open",
      '.chatlio-widget[data-state="open"]',
      // Iframe that is visible (often used for chat)
      'iframe[src*="chatlio"]:not([style*="display: none"])',
      // Elements with data attributes
      '[data-chatlio-open="true"]',
      '[data-chatlio-state="open"]'
    ];
    let chatFound = false;
    for (let selector of openChatSelectors) {
      const elements = document.querySelectorAll(selector);
      for (let element of elements) {
        const rect = element.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(element);
        if (rect.width > 50 && rect.height > 50 && // Minimum size
        computedStyle.display !== "none" && computedStyle.visibility !== "hidden" && parseFloat(computedStyle.opacity) > 0.1) {
          chatFound = true;
          break;
        }
      }
      if (chatFound) break;
    }
    if (!chatFound) {
      const chatIframes = document.querySelectorAll(
        'iframe[src*="chatlio"], iframe[id*="chatlio"]'
      );
      chatIframes.forEach((iframe) => {
        const rect = iframe.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(iframe);
        if (rect.width > 100 && rect.height > 100 && computedStyle.display !== "none" && computedStyle.visibility !== "hidden") {
          chatFound = true;
        }
      });
    }
    return chatFound;
  }
  updateChatState() {
    const actuallyOpen = this.checkChatStatus();
    if (actuallyOpen && !this.isChatOpen) {
      this.moveButtonsUp();
    } else if (!actuallyOpen && this.isChatOpen) {
      this.resetButtonsPosition();
    }
  }
  setupChatMonitoring() {
    this.observer = new MutationObserver((mutations) => {
      let shouldCheck = false;
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
          nodes.forEach((node) => {
            if (node.nodeType === 1) {
              const element = node;
              if (element.classList && (element.classList.contains("chatlio-chat-container") || element.classList.contains("chatlio-chat-window") || element.classList.contains("chatlio-widget"))) {
                shouldCheck = true;
              }
              if (element.querySelector && (element.querySelector(".chatlio-chat-container") || element.querySelector(".chatlio-chat-window") || element.querySelector(".chatlio-widget"))) {
                shouldCheck = true;
              }
            }
          });
        }
        if (mutation.type === "attributes" && (mutation.attributeName === "style" || mutation.attributeName === "class" || mutation.attributeName === "data-chatlio-open" || mutation.attributeName === "data-state")) {
          const target = mutation.target;
          if (target.classList && (target.classList.contains("chatlio-chat-container") || target.classList.contains("chatlio-chat-window") || target.classList.contains("chatlio-widget") || target.tagName === "IFRAME")) {
            shouldCheck = true;
          }
        }
      });
      if (shouldCheck) {
        setTimeout(() => this.updateChatState(), 100);
      }
    });
    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [
        "style",
        "class",
        "data-chatlio-open",
        "data-state",
        "src"
      ]
    });
    this.intervalId = window.setInterval(() => {
      const currentState = this.checkChatStatus();
      if (currentState !== this.lastChatState) {
        this.updateChatState();
        this.lastChatState = currentState;
      }
    }, 2e3);
  }
  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    document.documentElement.style.setProperty("--chatlio-offset", "0px");
  }
}
const chatButtonManager = new ChatButtonManagerImpl();
chatButtonManager.init();
function onMiniCartShown(_element) {
  const impressions = JSON.parse(localStorage.getItem("___ELEVAR_GTM_SUITE--cart") || "[]");
  let value = 0;
  impressions.forEach((product, i) => {
    product["position"] = i + 1;
    value += parseFloat(product["price"] || 0) * parseFloat(product["quantity"] || 1);
  });
  window.dataLayer.push({ ecommerce: null });
  window.ElevarDataLayer.push({
    event: "dl_view_cart",
    cart_total: value.toString(),
    ecommerce: {
      actionField: { list: "Mini Cart" },
      currencyCode: window.currentCurrencyCode,
      impressions
    }
  });
}
function attachMiniCartListener() {
  window.addEventListener("gtmIsMiniCartShown", function() {
    setTimeout(() => {
      onMiniCartShown();
    }, 100);
  });
}
function onNewsletterButtonClick(selector, leadType = "email") {
  var _a;
  const email = (_a = document.querySelector(selector)) == null ? void 0 : _a.value;
  if (!email) {
    return;
  }
  window.dataLayer.push({ ecommerce: null });
  window.ElevarDataLayer.push({
    event: "dl_subscribe",
    lead_type: leadType,
    user_properties: {
      email
    }
  });
}
function attachNewsletterButtonListener() {
  var _a, _b;
  (_a = document.querySelector(".newsletter-form .newsletter-button")) == null ? void 0 : _a.addEventListener("click", function() {
    if (this.disabled) {
      return;
    }
    onNewsletterButtonClick('.newsletter-form input[type="email"]');
  });
  (_b = document.querySelector('#ContactForm button[type="submit"]')) == null ? void 0 : _b.addEventListener("click", function() {
    onNewsletterButtonClick("#ContactForm #ContactForm-email", "contact-form");
  });
}
function attachGtmSelectItemListener(element, list) {
  element.addEventListener("click", function(_e) {
    const id = element.getAttribute("data-product-identifier") || element.getAttribute("key");
    if (!list && id) {
      list = Object.keys(window.gtmUpsellItems).find((key) => !!window.gtmUpsellItems[key][id]);
      if (!list) {
        return;
      }
    }
    if (list && id) {
      window.ElevarDataLayer.push({
        event: "dl_select_item",
        ecommerce: {
          currencyCode: window.currentCurrencyCode,
          click: {
            actionField: { list },
            products: [window.gtmUpsellItems[list][id] || {}]
          }
        }
      });
    }
  });
}
function attachGtmFeaturedCollectionListener() {
  document.querySelectorAll(".card-product").forEach((element) => {
    attachGtmSelectItemListener(element);
  });
}
function pushGtmUpsellEvents() {
  Object.keys(window.gtmUpsellItems).forEach((key) => {
    const items = Object.values(window.gtmUpsellItems[key] || []).sort(
      function(a, b) {
        return a.position - b.position;
      }
    );
    if (items.length === 0) {
      return;
    }
    window.dataLayer.push({ ecommerce: null });
    window.ElevarDataLayer.push({
      event: "dl_view_item_list",
      ecommerce: {
        currencyCode: window.currentCurrencyCode,
        impressions: items
      }
    });
  });
}
function checkSignUpEvent() {
  const signUpEvent = localStorage.getItem("gtmSignUpEvent");
  if (signUpEvent) {
    const eventData = JSON.parse(signUpEvent);
    window.dataLayer.push({ ecommerce: null });
    window.ElevarDataLayer.push(eventData);
    localStorage.removeItem("gtmSignUpEvent");
  }
}
function processRingBuilderConfigStartEvent() {
  const ringBuilderEvent = localStorage.getItem("gtmRingBuilderConfigStartEvent");
  if (ringBuilderEvent) {
    const eventData = JSON.parse(ringBuilderEvent);
    window.dataLayer.push({ ecommerce: null });
    window.ElevarDataLayer.push(eventData);
    localStorage.removeItem("gtmRingBuilderConfigStartEvent");
  }
}
function attachRingBuilderEventListeners() {
  console.log("Ring builder event listeners attached");
}
function onLimespotBlocksLoad() {
  console.log("Limespot blocks loaded");
}
function initElevarGtmCustomizations() {
  (() => {
    if (location.pathname.includes("rolex")) {
      return;
    }
    attachMiniCartListener();
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(() => {
        checkSignUpEvent();
        processRingBuilderConfigStartEvent();
        attachNewsletterButtonListener();
        attachRingBuilderEventListeners();
      }, 100);
      if (document.body.classList.contains("template-product")) {
        let pdpIntervalCount = 0;
        let pdpUpsellTimeout;
        const pdpLimespotInterval = setInterval(() => {
          const gtmIsPdpLimespotLoaded = !!document.querySelector("limespot [data-product-identifier]");
          if (window.ElevarDataLayer && gtmIsPdpLimespotLoaded || pdpIntervalCount > 20) {
            clearInterval(pdpLimespotInterval);
            if (window.ElevarDataLayer && gtmIsPdpLimespotLoaded) {
              pdpUpsellTimeout = setTimeout(() => {
                onLimespotBlocksLoad();
              }, 100);
            }
            return;
          }
          pdpIntervalCount++;
        }, 500);
        window.addEventListener("beforeunload", () => {
          clearInterval(pdpLimespotInterval);
          clearTimeout(pdpUpsellTimeout);
        });
      } else {
        let gtmUpsellTimeout;
        let intervalCount = 0;
        const upsellInterval = setInterval(() => {
          if (window.ElevarDataLayer || intervalCount > 20) {
            clearInterval(upsellInterval);
            if (!window.ElevarDataLayer) {
              return;
            }
            processRingBuilderConfigStartEvent();
            gtmUpsellTimeout = setTimeout(() => {
              if (!window.gtmUpsellItems) {
                return;
              }
              pushGtmUpsellEvents();
              attachGtmFeaturedCollectionListener();
            }, 100);
            return;
          }
          intervalCount++;
        }, 200);
        window.addEventListener("beforeunload", () => {
          clearInterval(upsellInterval);
          clearTimeout(gtmUpsellTimeout);
        });
      }
    });
  })();
}
const LetsTalkAboutIt = () => ({
  openChat() {
    const chatlioTitleBar = document.querySelector(".chatlio-title-bar");
    if (chatlioTitleBar) {
      chatlioTitleBar.dispatchEvent(
        new MouseEvent("click", {
          bubbles: true,
          cancelable: true,
          view: window
        })
      );
    }
  },
  handleEmail(email) {
    const cleanEmail = email.replace(/<[^>]*>?/gm, "").trim();
    if (cleanEmail) {
      window.location.href = `mailto:${cleanEmail}`;
    }
  },
  handlePhone(phone) {
    const cleanPhone = phone.replace(/<[^>]*>?/gm, "").trim();
    if (cleanPhone) {
      window.location.href = `tel:${cleanPhone}`;
    }
  }
});
const DIAMOND_API_URL = "https://diamond-service.jrdunn.com";
const ReservationForm = (initialData = {}) => ({
  // Alpine.js reactive state
  _formRef: null,
  closeBtn: null,
  _translatedErrors: initialData.translatedErrors || {},
  isSubmitted: false,
  isLoading: false,
  isSuccess: false,
  isError: false,
  isFormValid: false,
  requestError: false,
  // Global errors object for Alpine.js reactivity
  errors: {},
  /**
   * Initialize the form, this could include fetching translations or setting up defaults
   */
  init() {
    this._translatedErrors;
  },
  /**
   * Validates individual field based on the value
   */
  validateField(fieldKey, value) {
    this.errors[fieldKey] = "";
    if (value === "") {
      this.errors[fieldKey] = this._translatedErrors[`${fieldKey}Required`];
      return false;
    }
    switch (fieldKey) {
      case "clientName":
      case "salesPersonName":
        if (!/^[\p{L}\s]+$/u.test(value)) {
          this.errors[fieldKey] = this._translatedErrors[`${fieldKey}Invalid`];
          return false;
        }
        break;
      case "clientTelephone":
        if (!/^\+?[1-9]{1}[0-9\s\-\(\)\.]{6,19}$/.test(value)) {
          this.errors[fieldKey] = this._translatedErrors[`${fieldKey}Invalid`];
          return false;
        }
        break;
      case "neededBy":
        if (new Date(value).getTime() <= (/* @__PURE__ */ new Date()).getTime()) {
          this.errors[fieldKey] = this._translatedErrors[`${fieldKey}Invalid`];
          return false;
        }
        break;
      case "clientEmail":
      case "associatesEmail":
        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
          this.errors[fieldKey] = this._translatedErrors[`${fieldKey}Invalid`];
          return false;
        }
        break;
    }
    return true;
  },
  /**
   * Validates the entire form
   */
  _validateForm() {
    const allFields = [
      "clientName",
      "clientTelephone",
      "salesPersonName",
      "neededBy",
      "clientAddress",
      "clientEmail",
      "associatesEmail"
    ];
    allFields.forEach((field) => {
      const value = this.$refs[field].value.trim();
      this.validateField(field, value);
    });
    Object.keys(this.errors).forEach((key) => {
      if (this.errors[key] === null || this.errors[key] === void 0 || this.errors[key] === "") {
        delete this.errors[key];
      }
    });
    if (Object.keys(this.errors).length > 0) {
      return false;
    } else {
      return true;
    }
  },
  /**
   * Handles form submission
   */
  async handleSubmit(event) {
    var _a, _b, _c;
    event.preventDefault();
    this.closeBtn = this.$refs.closeButton;
    this.isSubmitted = true;
    if (!this._validateForm()) {
      this.isError = true;
      return;
    }
    this.isLoading = true;
    this.isSuccess = false;
    this.isError = false;
    this._formRef = event.target;
    try {
      const formData = new FormData(this._formRef);
      const body = JSON.stringify(Object.fromEntries(formData.entries()));
      const shopifyShop = window.Shopify.shop;
      const customerId = (_a = window.ShopifyAnalytics) == null ? void 0 : _a.meta.page.customerId;
      const encodedCustomerId = customerId ? btoa(String(customerId)) : customerId;
      const headers = {
        "Content-Type": "application/json",
        shop: shopifyShop
      };
      if (encodedCustomerId) {
        headers["customer-id"] = encodedCustomerId;
      }
      const response = await fetch(`${DIAMOND_API_URL}/reserve-diamond`, {
        method: "POST",
        headers,
        body
      });
      if (response.ok) {
        this.isSuccess = true;
        setTimeout(() => {
          this.isSuccess = false;
        }, 5e3);
        this._formRef.reset();
        this.isSubmitted = false;
        (_b = this.closeBtn) == null ? void 0 : _b.click();
      } else {
        this.requestError = true;
        throw new Error("Failed to submit");
      }
    } catch (error) {
      this.requestError = true;
      setTimeout(() => {
        this.requestError = false;
      }, 5e3);
      this._formRef.reset();
      this.isSubmitted = false;
      (_c = this.closeBtn) == null ? void 0 : _c.click();
    } finally {
      this.isLoading = false;
    }
  }
});
const ProductRequestForm = () => ({
  isLoading: false,
  isSuccess: false,
  isError: false,
  /**
   * Handles form submission
   */
  async handleSubmit(event) {
    this.isLoading = true;
    this.isSuccess = false;
    this.isError = false;
    const form = event.target;
    try {
      const formData = new FormData(form);
      const body = JSON.stringify(Object.fromEntries(formData.entries()));
      const response = await fetch(`${DIAMOND_API_URL}/request-tudor-watch`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body
      });
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const result = await response.json();
      if (result.success) {
        this.isSuccess = true;
        form.reset();
      } else {
        this.isError = true;
      }
    } catch (error) {
      this.isError = true;
    } finally {
      this.isLoading = false;
    }
  }
});
const DiamondStepFilters = () => ({
  // Sorting orders from best to worst quality (left to right) - only for allowed values
  claritySortOrder: ["FL", "IF", "VVS1", "VVS2", "VS1", "VS2", "SI1", "SI2", "I1"],
  colorSortOrder: ["D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  cutSortOrder: ["Fair", "Good", "Very Good", "Excellent"],
  fluorescenceSortOrder: ["None", "Faint", "Medium", "Strong", "Very Strong"],
  polishSortOrder: ["Poor", "Fair", "Good", "Very Good", "Excellent"],
  symmetrySortOrder: ["Poor", "Fair", "Good", "Very Good", "Excellent"],
  // Allowed values for each filter
  allowedClarityValues: ["FL", "IF", "VVS1", "VVS2", "VS1", "VS2", "SI1", "SI2", "I1"],
  allowedColorValues: ["D", "E", "F", "G", "H", "I", "J", "K", "L", "M"],
  allowedCutValues: ["Fair", "Good", "Very Good", "Excellent"],
  allowedFluorescenceValues: ["None", "Faint", "Medium", "Strong", "Very Strong"],
  allowedPolishValues: ["Poor", "Fair", "Good", "Very Good", "Excellent"],
  allowedSymmetryValues: ["Poor", "Fair", "Good", "Very Good", "Excellent"],
  // Range indices for sliders
  clarityRange: [0, 0],
  colorRange: [0, 0],
  cutRange: [0, 0],
  fluorescenceRange: [0, 0],
  polishRange: [0, 0],
  symmetryRange: [0, 0],
  isDragging: false,
  dragType: "",
  // Filter dropdown expanded states
  fluorescenceExpanded: false,
  polishExpanded: false,
  symmetryExpanded: false,
  // Initialization flags
  isInitializing: true,
  clarityInitialized: false,
  colorInitialized: false,
  cutInitialized: false,
  fluorescenceInitialized: false,
  polishInitialized: false,
  symmetryInitialized: false,
  // Performance optimization properties
  _debouncedApplyFilters: null,
  _pendingFilterApplication: false,
  _lastFilterApplicationTime: 0,
  // Debounced filter application - prevents excessive FastSimon calls
  debouncedApplyFilters() {
    if (this._debouncedApplyFilters) {
      clearTimeout(this._debouncedApplyFilters);
      this._debouncedApplyFilters = null;
    }
    this._debouncedApplyFilters = setTimeout(() => {
      this.applyFiltersToFastSimon();
      this._debouncedApplyFilters = null;
    }, 150);
  },
  // Helper function to determine which thumb is closest to mouse position
  getClosestThumb(clientX, element, minIndex, maxIndex, totalOptions) {
    const rect = element.getBoundingClientRect();
    const relativeX = clientX - rect.left;
    const percentageX = Math.max(0, Math.min(1, relativeX / rect.width));
    const clickedIndex = Math.round(percentageX * (totalOptions - 1));
    const distanceToMin = Math.abs(clickedIndex - minIndex);
    const distanceToMax = Math.abs(clickedIndex - maxIndex);
    if (minIndex === maxIndex) {
      return clickedIndex <= minIndex ? "min" : "max";
    }
    if (Math.abs(maxIndex - minIndex) <= 1) {
      if (clickedIndex < minIndex) {
        return "min";
      } else if (clickedIndex > maxIndex) {
        return "max";
      } else {
        const minThumbPos = minIndex / (totalOptions - 1);
        const maxThumbPos = maxIndex / (totalOptions - 1);
        const avgThumbPos = (minThumbPos + maxThumbPos) / 2;
        return percentageX < avgThumbPos ? "min" : "max";
      }
    }
    if (distanceToMin < distanceToMax) {
      return "min";
    } else if (distanceToMax < distanceToMin) {
      return "max";
    } else {
      return percentageX < 0.5 ? "min" : "max";
    }
  },
  // Smart interaction handlers for Clarity
  handleClarityMouseDown(event) {
    if (this.clarityOptions.length === 0) return;
    const closestThumb = this.getClosestThumb(
      event.clientX,
      event.target,
      this.clarityRange[0],
      this.clarityRange[1],
      this.clarityOptions.length
    );
    this.isDragging = true;
    this.dragType = `clarity-${closestThumb}`;
  },
  handleClarityTouchStart(event) {
    if (this.clarityOptions.length === 0 || !(event == null ? void 0 : event.touches[0])) return;
    event.preventDefault();
    event.stopPropagation();
    const touch = event.touches[0];
    const closestThumb = this.getClosestThumb(
      touch.clientX,
      event.target,
      this.clarityRange[0],
      this.clarityRange[1],
      this.clarityOptions.length
    );
    this.__initialTouchX = touch.clientX;
    this.__initialValue = closestThumb === "min" ? this.clarityRange[0] : this.clarityRange[1];
    const thumb = event.target;
    const sliderContainer = thumb.closest(".diamond-step-filter") || thumb.closest('[data-filter="clarity"]');
    if (!sliderContainer) {
      console.warn("Diamond step filter container not found");
      return;
    }
    this.__trackRect = sliderContainer.getBoundingClientRect();
    this.__containerLeft = this.__trackRect.left;
    this.__containerWidth = this.__trackRect.width;
    this.isDragging = true;
    this.dragType = `clarity-${closestThumb}`;
  },
  handleClarityInput(event) {
    if (this.clarityOptions.length === 0) return;
    const input = event.target;
    const newValue = parseInt(input.value);
    if (this.dragType === "clarity-min") {
      const newRange = [Math.min(newValue, this.clarityRange[1]), this.clarityRange[1]];
      this.clarityRange = newRange;
    } else if (this.dragType === "clarity-max") {
      const newRange = [this.clarityRange[0], Math.max(newValue, this.clarityRange[0])];
      this.clarityRange = newRange;
    }
  },
  handleClarityMouseMove(event) {
    if (!this.isDragging || this.clarityOptions.length === 0) return;
    const areThumbsClose = Math.abs(this.clarityRange[1] - this.clarityRange[0]) <= 1;
    if (!areThumbsClose) return;
    const newClosestThumb = this.getClosestThumb(
      event.clientX,
      event.target,
      this.clarityRange[0],
      this.clarityRange[1],
      this.clarityOptions.length
    );
    const newDragType = `clarity-${newClosestThumb}`;
    if (this.dragType !== newDragType) {
      this.dragType = newDragType;
    }
  },
  // Smart interaction handlers for Color
  handleColorMouseDown(event) {
    if (this.colorOptions.length === 0) return;
    const closestThumb = this.getClosestThumb(
      event.clientX,
      event.target,
      this.colorRange[0],
      this.colorRange[1],
      this.colorOptions.length
    );
    this.isDragging = true;
    this.dragType = `color-${closestThumb}`;
  },
  handleColorTouchStart(event) {
    if (this.colorOptions.length === 0 || !(event == null ? void 0 : event.touches[0])) return;
    event.preventDefault();
    event.stopPropagation();
    const touch = event.touches[0];
    const closestThumb = this.getClosestThumb(
      touch.clientX,
      event.target,
      this.colorRange[0],
      this.colorRange[1],
      this.colorOptions.length
    );
    this.__initialTouchX = touch.clientX;
    this.__initialValue = closestThumb === "min" ? this.colorRange[0] : this.colorRange[1];
    const thumb = event.target;
    const sliderContainer = thumb.closest(".diamond-step-filter") || thumb.closest('[data-filter="color"]');
    if (!sliderContainer) {
      console.warn("Diamond step filter container not found");
      return;
    }
    this.__trackRect = sliderContainer.getBoundingClientRect();
    this.__containerLeft = this.__trackRect.left;
    this.__containerWidth = this.__trackRect.width;
    this.isDragging = true;
    this.dragType = `color-${closestThumb}`;
  },
  handleColorInput(event) {
    if (this.colorOptions.length === 0) return;
    const input = event.target;
    const newValue = parseInt(input.value);
    if (this.dragType === "color-min") {
      const newRange = [Math.min(newValue, this.colorRange[1]), this.colorRange[1]];
      this.colorRange = newRange;
    } else if (this.dragType === "color-max") {
      const newRange = [this.colorRange[0], Math.max(newValue, this.colorRange[0])];
      this.colorRange = newRange;
    }
  },
  handleColorMouseMove(event) {
    if (!this.isDragging || this.colorOptions.length === 0) return;
    const areThumbsClose = Math.abs(this.colorRange[1] - this.colorRange[0]) <= 1;
    if (!areThumbsClose) return;
    const newClosestThumb = this.getClosestThumb(
      event.clientX,
      event.target,
      this.colorRange[0],
      this.colorRange[1],
      this.colorOptions.length
    );
    const newDragType = `color-${newClosestThumb}`;
    if (this.dragType !== newDragType) {
      this.dragType = newDragType;
    }
  },
  // Smart interaction handlers for Cut
  handleCutMouseDown(event) {
    if (this.cutOptions.length === 0) return;
    const closestThumb = this.getClosestThumb(
      event.clientX,
      event.target,
      this.cutRange[0],
      this.cutRange[1],
      this.cutOptions.length
    );
    this.isDragging = true;
    this.dragType = `cut-${closestThumb}`;
  },
  handleCutTouchStart(event) {
    if (this.cutOptions.length === 0 || !(event == null ? void 0 : event.touches[0])) return;
    event.preventDefault();
    event.stopPropagation();
    const touch = event.touches[0];
    const closestThumb = this.getClosestThumb(
      touch.clientX,
      event.target,
      this.cutRange[0],
      this.cutRange[1],
      this.cutOptions.length
    );
    this.__initialTouchX = touch.clientX;
    this.__initialValue = closestThumb === "min" ? this.cutRange[0] : this.cutRange[1];
    const thumb = event.target;
    const sliderContainer = thumb.closest(".diamond-step-filter") || thumb.closest('[data-filter="cut"]');
    if (!sliderContainer) {
      console.warn("Diamond step filter container not found");
      return;
    }
    this.__trackRect = sliderContainer.getBoundingClientRect();
    this.__containerLeft = this.__trackRect.left;
    this.__containerWidth = this.__trackRect.width;
    this.isDragging = true;
    this.dragType = `cut-${closestThumb}`;
  },
  handleCutInput(event) {
    if (this.cutOptions.length === 0) return;
    const input = event.target;
    const newValue = parseInt(input.value);
    if (this.dragType === "cut-min") {
      const newRange = [Math.min(newValue, this.cutRange[1]), this.cutRange[1]];
      this.cutRange = newRange;
    } else if (this.dragType === "cut-max") {
      const newRange = [this.cutRange[0], Math.max(newValue, this.cutRange[0])];
      this.cutRange = newRange;
    }
  },
  handleCutMouseMove(event) {
    if (!this.isDragging || this.cutOptions.length === 0) return;
    const areThumbsClose = Math.abs(this.cutRange[1] - this.cutRange[0]) <= 1;
    if (!areThumbsClose) return;
    const newClosestThumb = this.getClosestThumb(
      event.clientX,
      event.target,
      this.cutRange[0],
      this.cutRange[1],
      this.cutOptions.length
    );
    const newDragType = `cut-${newClosestThumb}`;
    if (this.dragType !== newDragType) {
      this.dragType = newDragType;
    }
  },
  // Smart interaction handlers for Fluorescence
  handleFluorescenceMouseDown(event) {
    if (this.fluorescenceOptions.length === 0) return;
    const closestThumb = this.getClosestThumb(
      event.clientX,
      event.target,
      this.fluorescenceRange[0],
      this.fluorescenceRange[1],
      this.fluorescenceOptions.length
    );
    this.isDragging = true;
    this.dragType = `fluorescence-${closestThumb}`;
  },
  handleFluorescenceTouchStart(event) {
    if (this.fluorescenceOptions.length === 0 || !(event == null ? void 0 : event.touches[0])) return;
    event.preventDefault();
    event.stopPropagation();
    const touch = event.touches[0];
    const closestThumb = this.getClosestThumb(
      touch.clientX,
      event.target,
      this.fluorescenceRange[0],
      this.fluorescenceRange[1],
      this.fluorescenceOptions.length
    );
    this.__initialTouchX = touch.clientX;
    this.__initialValue = closestThumb === "min" ? this.fluorescenceRange[0] : this.fluorescenceRange[1];
    const thumb = event.target;
    const sliderContainer = thumb.closest(".diamond-step-filter") || thumb.closest('[data-filter="fluorescence"]');
    if (!sliderContainer) {
      console.warn("Diamond step filter container not found");
      return;
    }
    this.__trackRect = sliderContainer.getBoundingClientRect();
    this.__containerLeft = this.__trackRect.left;
    this.__containerWidth = this.__trackRect.width;
    this.isDragging = true;
    this.dragType = `fluorescence-${closestThumb}`;
  },
  handleFluorescenceInput(event) {
    if (this.fluorescenceOptions.length === 0) return;
    const input = event.target;
    const newValue = parseInt(input.value);
    if (this.dragType === "fluorescence-min") {
      const newRange = [Math.min(newValue, this.fluorescenceRange[1]), this.fluorescenceRange[1]];
      this.fluorescenceRange = newRange;
    } else if (this.dragType === "fluorescence-max") {
      const newRange = [this.fluorescenceRange[0], Math.max(newValue, this.fluorescenceRange[0])];
      this.fluorescenceRange = newRange;
    }
  },
  handleFluorescenceMouseMove(event) {
    if (!this.isDragging || this.fluorescenceOptions.length === 0) return;
    const areThumbsClose = Math.abs(this.fluorescenceRange[1] - this.fluorescenceRange[0]) <= 1;
    if (!areThumbsClose) return;
    const newClosestThumb = this.getClosestThumb(
      event.clientX,
      event.target,
      this.fluorescenceRange[0],
      this.fluorescenceRange[1],
      this.fluorescenceOptions.length
    );
    const newDragType = `fluorescence-${newClosestThumb}`;
    if (this.dragType !== newDragType) {
      this.dragType = newDragType;
    }
  },
  // Smart interaction handlers for Polish
  handlePolishMouseDown(event) {
    if (this.polishOptions.length === 0) return;
    const closestThumb = this.getClosestThumb(
      event.clientX,
      event.target,
      this.polishRange[0],
      this.polishRange[1],
      this.polishOptions.length
    );
    this.isDragging = true;
    this.dragType = `polish-${closestThumb}`;
  },
  handlePolishTouchStart(event) {
    if (this.polishOptions.length === 0 || !(event == null ? void 0 : event.touches[0])) return;
    event.preventDefault();
    event.stopPropagation();
    const touch = event.touches[0];
    const closestThumb = this.getClosestThumb(
      touch.clientX,
      event.target,
      this.polishRange[0],
      this.polishRange[1],
      this.polishOptions.length
    );
    this.__initialTouchX = touch.clientX;
    this.__initialValue = closestThumb === "min" ? this.polishRange[0] : this.polishRange[1];
    const thumb = event.target;
    const sliderContainer = thumb.closest(".diamond-step-filter") || thumb.closest('[data-filter="polish"]');
    if (!sliderContainer) {
      console.warn("Diamond step filter container not found");
      return;
    }
    this.__trackRect = sliderContainer.getBoundingClientRect();
    this.__containerLeft = this.__trackRect.left;
    this.__containerWidth = this.__trackRect.width;
    this.isDragging = true;
    this.dragType = `polish-${closestThumb}`;
  },
  handlePolishInput(event) {
    if (this.polishOptions.length === 0) return;
    const input = event.target;
    const newValue = parseInt(input.value);
    if (this.dragType === "polish-min") {
      const newRange = [Math.min(newValue, this.polishRange[1]), this.polishRange[1]];
      this.polishRange = newRange;
    } else if (this.dragType === "polish-max") {
      const newRange = [this.polishRange[0], Math.max(newValue, this.polishRange[0])];
      this.polishRange = newRange;
    }
  },
  handlePolishMouseMove(event) {
    if (!this.isDragging || this.polishOptions.length === 0) return;
    const areThumbsClose = Math.abs(this.polishRange[1] - this.polishRange[0]) <= 1;
    if (!areThumbsClose) return;
    const newClosestThumb = this.getClosestThumb(
      event.clientX,
      event.target,
      this.polishRange[0],
      this.polishRange[1],
      this.polishOptions.length
    );
    const newDragType = `polish-${newClosestThumb}`;
    if (this.dragType !== newDragType) {
      this.dragType = newDragType;
    }
  },
  // Smart interaction handlers for Symmetry
  handleSymmetryMouseDown(event) {
    if (this.symmetryOptions.length === 0) return;
    const closestThumb = this.getClosestThumb(
      event.clientX,
      event.target,
      this.symmetryRange[0],
      this.symmetryRange[1],
      this.symmetryOptions.length
    );
    this.isDragging = true;
    this.dragType = `symmetry-${closestThumb}`;
  },
  handleSymmetryTouchStart(event) {
    if (this.symmetryOptions.length === 0 || !(event == null ? void 0 : event.touches[0])) return;
    event.preventDefault();
    event.stopPropagation();
    const touch = event.touches[0];
    const closestThumb = this.getClosestThumb(
      touch.clientX,
      event.target,
      this.symmetryRange[0],
      this.symmetryRange[1],
      this.symmetryOptions.length
    );
    this.__initialTouchX = touch.clientX;
    this.__initialValue = closestThumb === "min" ? this.symmetryRange[0] : this.symmetryRange[1];
    const thumb = event.target;
    const sliderContainer = thumb.closest(".diamond-step-filter") || thumb.closest('[data-filter="symmetry"]');
    if (!sliderContainer) {
      console.warn("Diamond step filter container not found");
      return;
    }
    this.__trackRect = sliderContainer.getBoundingClientRect();
    this.__containerLeft = this.__trackRect.left;
    this.__containerWidth = this.__trackRect.width;
    this.isDragging = true;
    this.dragType = `symmetry-${closestThumb}`;
  },
  handleSymmetryInput(event) {
    if (this.symmetryOptions.length === 0) return;
    const input = event.target;
    const newValue = parseInt(input.value);
    if (this.dragType === "symmetry-min") {
      const newRange = [Math.min(newValue, this.symmetryRange[1]), this.symmetryRange[1]];
      this.symmetryRange = newRange;
    } else if (this.dragType === "symmetry-max") {
      const newRange = [this.symmetryRange[0], Math.max(newValue, this.symmetryRange[0])];
      this.symmetryRange = newRange;
    }
  },
  handleSymmetryMouseMove(event) {
    if (!this.isDragging || this.symmetryOptions.length === 0) return;
    const areThumbsClose = Math.abs(this.symmetryRange[1] - this.symmetryRange[0]) <= 1;
    if (!areThumbsClose) return;
    const newClosestThumb = this.getClosestThumb(
      event.clientX,
      event.target,
      this.symmetryRange[0],
      this.symmetryRange[1],
      this.symmetryOptions.length
    );
    const newDragType = `symmetry-${newClosestThumb}`;
    if (this.dragType !== newDragType) {
      this.dragType = newDragType;
    }
  },
  // Generic touch handlers for all filter types
  onThumbTouchMove(event) {
    if (!this.isDragging || !this.dragType || !event.touches[0]) return;
    event.preventDefault();
    event.stopPropagation();
    const touch = event.touches[0];
    const relativeX = touch.clientX - this.__containerLeft;
    const percentage = Math.max(0, Math.min(1, relativeX / this.__containerWidth));
    const [filterType, thumb] = this.dragType.split("-");
    let options = [];
    let currentRange = [];
    switch (filterType) {
      case "clarity":
        options = this.clarityOptions;
        currentRange = [...this.clarityRange];
        break;
      case "color":
        options = this.colorOptions;
        currentRange = [...this.colorRange];
        break;
      case "cut":
        options = this.cutOptions;
        currentRange = [...this.cutRange];
        break;
      case "fluorescence":
        options = this.fluorescenceOptions;
        currentRange = [...this.fluorescenceRange];
        break;
      case "polish":
        options = this.polishOptions;
        currentRange = [...this.polishRange];
        break;
      case "symmetry":
        options = this.symmetryOptions;
        currentRange = [...this.symmetryRange];
        break;
      default:
        return;
    }
    if (options.length === 0) return;
    const newIndex = Math.round(percentage * (options.length - 1));
    const clampedIndex = Math.max(0, Math.min(options.length - 1, newIndex));
    if (thumb === "min") {
      currentRange[0] = Math.min(clampedIndex, currentRange[1]);
    } else {
      currentRange[1] = Math.max(clampedIndex, currentRange[0]);
    }
    switch (filterType) {
      case "clarity":
        this.clarityRange = currentRange;
        break;
      case "color":
        this.colorRange = currentRange;
        break;
      case "cut":
        this.cutRange = currentRange;
        break;
      case "fluorescence":
        this.fluorescenceRange = currentRange;
        break;
      case "polish":
        this.polishRange = currentRange;
        break;
      case "symmetry":
        this.symmetryRange = currentRange;
        break;
    }
  },
  onThumbTouchEnd() {
    if (!this.isDragging) return;
    delete this.__initialTouchX;
    delete this.__initialValue;
    delete this.__trackRect;
    delete this.__containerLeft;
    delete this.__containerWidth;
    this.isDragging = false;
    const wasFiltering = this.dragType !== "";
    this.dragType = "";
    if (wasFiltering && !this.isInitializing) {
      setTimeout(() => {
        this.applyFiltersToFastSimon();
      }, 0);
    }
  },
  onThumbTouchCancel() {
    if (this.isDragging) {
      delete this.__initialTouchX;
      delete this.__initialValue;
      delete this.__trackRect;
      delete this.__containerLeft;
      delete this.__containerWidth;
      this.isDragging = false;
      this.dragType = "";
    }
  },
  // Helper function to sort values based on predefined order
  sortValuesByOrder(values, sortOrder) {
    if (!values || !Array.isArray(values)) return [];
    const orderMap = {};
    sortOrder.forEach((value, index) => {
      orderMap[value] = index;
    });
    const knownValues = values.filter((value) => orderMap[value] !== void 0);
    const unknownValues = values.filter((value) => orderMap[value] === void 0);
    const sortedKnown = knownValues.sort((a, b) => {
      return orderMap[a] - orderMap[b];
    });
    const sortedUnknown = unknownValues.sort();
    return [...sortedKnown, ...sortedUnknown];
  },
  // Get diamond filters from FastSimon
  get diamondFilters() {
    const store = Alpine.store("fastSimon");
    const allFilters = (store == null ? void 0 : store.fastSimonFilters) || [];
    const diamondFilters = allFilters.filter((filter) => {
      const paramName = filter.param_name || "";
      const label = (filter.label || "").toLowerCase();
      return paramName.startsWith("filter.p.d.") || paramName.startsWith("filter.p.m.") && ["clarity", "color", "cut", "fluorescence_intensity", "fluorescence", "polish", "symmetry"].includes(label) || ["clarity", "color", "cut", "fluorescence_intensity", "fluorescence", "fluorescence intensity", "polish", "symmetry"].includes(label);
    });
    return diamondFilters;
  },
  get clarityFilter() {
    return this.diamondFilters.find(
      (f) => f.param_name === "filter.p.d.clarity" || f.param_name === "filter.p.m.clarity" || f.label && f.label.toLowerCase() === "clarity"
    );
  },
  get colorFilter() {
    return this.diamondFilters.find(
      (f) => f.param_name === "filter.p.d.color" || f.param_name === "filter.p.m.color" || f.label && f.label.toLowerCase() === "color"
    );
  },
  get cutFilter() {
    return this.diamondFilters.find(
      (f) => f.param_name === "filter.p.d.cut" || f.param_name === "filter.p.m.cut" || f.label && f.label.toLowerCase() === "cut"
    );
  },
  get fluorescenceFilter() {
    return this.diamondFilters.find(
      (f) => f.param_name === "filter.p.d.fluorescence_intensity" || f.param_name === "filter.p.m.fluorescence_intensity" || f.param_name === "filter.p.d.fluorescence" || f.param_name === "filter.p.m.fluorescence" || f.label && (f.label.toLowerCase() === "fluorescence_intensity" || f.label.toLowerCase() === "fluorescence" || f.label.toLowerCase() === "fluorescence intensity")
    );
  },
  get polishFilter() {
    return this.diamondFilters.find(
      (f) => f.param_name === "filter.p.d.polish" || f.param_name === "filter.p.m.polish" || f.label && f.label.toLowerCase() === "polish"
    );
  },
  get symmetryFilter() {
    return this.diamondFilters.find(
      (f) => f.param_name === "filter.p.d.symmetry" || f.param_name === "filter.p.m.symmetry" || f.label && f.label.toLowerCase() === "symmetry"
    );
  },
  get clarityOptions() {
    var _a;
    if (!((_a = this.clarityFilter) == null ? void 0 : _a.values)) return [];
    const rawValues = this.clarityFilter.values.filter((v) => v.value !== "-" && this.allowedClarityValues.includes(v.value)).map((v) => v.value);
    return this.sortValuesByOrder(rawValues, this.claritySortOrder);
  },
  get colorOptions() {
    var _a;
    if (!((_a = this.colorFilter) == null ? void 0 : _a.values)) return [];
    const rawValues = this.colorFilter.values.filter((v) => v.value !== "-" && this.allowedColorValues.includes(v.value)).map((v) => v.value);
    return this.sortValuesByOrder(rawValues, this.colorSortOrder);
  },
  get cutOptions() {
    var _a;
    if (!((_a = this.cutFilter) == null ? void 0 : _a.values)) return [];
    const rawValues = this.cutFilter.values.filter((v) => v.value !== "-" && this.allowedCutValues.includes(v.value)).map((v) => v.value);
    return this.sortValuesByOrder(rawValues, this.cutSortOrder);
  },
  get fluorescenceOptions() {
    var _a;
    if (!((_a = this.fluorescenceFilter) == null ? void 0 : _a.values)) return [];
    const valueMap = {
      "non": "None",
      "none": "None",
      "fnt": "Faint",
      "faint": "Faint",
      "med": "Medium",
      "medium": "Medium",
      "stg": "Strong",
      "strong": "Strong",
      "vst": "Very Strong",
      "very strong": "Very Strong"
    };
    const normalizedValues = this.fluorescenceFilter.values.filter((v) => v.value !== "-").map((v) => {
      const normalizedValue = String(v.value).toLowerCase();
      return valueMap[normalizedValue] || v.label || v.value;
    }).filter((value) => this.allowedFluorescenceValues.includes(value));
    const uniqueValues = Array.from(new Set(normalizedValues));
    return this.sortValuesByOrder(uniqueValues, this.fluorescenceSortOrder);
  },
  get polishOptions() {
    var _a;
    if (!((_a = this.polishFilter) == null ? void 0 : _a.values)) return [];
    const rawValues = this.polishFilter.values.filter((v) => v.value !== "-" && this.allowedPolishValues.includes(v.value)).map((v) => v.value);
    return this.sortValuesByOrder(rawValues, this.polishSortOrder);
  },
  get symmetryOptions() {
    var _a;
    if (!((_a = this.symmetryFilter) == null ? void 0 : _a.values)) return [];
    const valueMap = {
      "poor": "Poor",
      "Poor": "Poor",
      "P": "Poor",
      "fair": "Fair",
      "Fair": "Fair",
      "F": "Fair",
      "good": "Good",
      "Good": "Good",
      "G": "Good",
      "very good": "Very Good",
      "Very Good": "Very Good",
      "VG": "Very Good",
      "excellent": "Excellent",
      "Excellent": "Excellent",
      "EX": "Excellent"
    };
    const normalizedValues = this.symmetryFilter.values.filter((v) => v.value !== "-").map((v) => {
      const originalValue = String(v.value);
      return valueMap[originalValue] || originalValue;
    }).filter((value) => value && ["Poor", "Fair", "Good", "Very Good", "Excellent"].includes(value));
    const uniqueValues = Array.from(new Set(normalizedValues));
    return this.sortValuesByOrder(uniqueValues, this.symmetrySortOrder);
  },
  init() {
    this.$watch("$store.fastSimon.fastSimonFilters", (filters) => {
      if (filters && filters.length > 0) {
        this.initializeFilters();
      }
    });
    const store = Alpine.store("fastSimon");
    if ((store == null ? void 0 : store.fastSimonFilters) && store.fastSimonFilters.length > 0) {
      setTimeout(() => this.initializeFilters(), 100);
    }
    this.$watch("clarityOptions", () => {
      if (this.clarityOptions.length > 0 && !this.clarityInitialized) {
        this.initializeClarityFromURL();
        this.clarityInitialized = true;
        this.checkInitializationComplete();
      }
    });
    this.$watch("colorOptions", () => {
      if (this.colorOptions.length > 0 && !this.colorInitialized) {
        this.initializeColorFromURL();
        this.colorInitialized = true;
        this.checkInitializationComplete();
      }
    });
    this.$watch("cutOptions", () => {
      if (this.cutOptions.length > 0 && !this.cutInitialized) {
        this.initializeCutFromURL();
        this.cutInitialized = true;
        this.checkInitializationComplete();
      }
    });
    this.$watch("fluorescenceOptions", () => {
      if (this.fluorescenceOptions.length > 0 && !this.fluorescenceInitialized) {
        this.initializeFluorescenceFromURL();
        this.fluorescenceInitialized = true;
        this.checkInitializationComplete();
      }
    });
    this.$watch("polishOptions", () => {
      if (this.polishOptions.length > 0 && !this.polishInitialized) {
        this.initializePolishFromURL();
        this.polishInitialized = true;
        this.checkInitializationComplete();
      }
    });
    this.$watch("symmetryOptions", () => {
      if (this.symmetryOptions.length > 0 && !this.symmetryInitialized) {
        this.initializeSymmetryFromURL();
        this.symmetryInitialized = true;
        this.checkInitializationComplete();
      }
    });
    const handleRangeChange = () => {
      if (!this.isInitializing && !this.isDragging) {
        const anyFilterInitialized = this.clarityInitialized || this.colorInitialized || this.cutInitialized || this.fluorescenceInitialized || this.polishInitialized || this.symmetryInitialized;
        if (anyFilterInitialized) {
          this.debouncedApplyFilters();
        }
      }
    };
    this.$watch("clarityRange", () => {
      handleRangeChange();
    });
    this.$watch("colorRange", () => {
      handleRangeChange();
    });
    this.$watch("cutRange", () => {
      handleRangeChange();
    });
    this.$watch("fluorescenceRange", () => {
      handleRangeChange();
    });
    this.$watch("polishRange", () => {
      handleRangeChange();
    });
    this.$watch("symmetryRange", () => {
      handleRangeChange();
    });
    this.$watch("isDragging", (newVal, oldVal) => {
      if (oldVal === true && newVal === false && !this.isInitializing) {
        this.debouncedApplyFilters();
      }
    });
    this.$watch("$store.fastSimon.getAppliedFiltersCount()", (newCount, oldCount) => {
      if (this.isInitializing) return;
      if (newCount < oldCount || newCount === 0) {
        this.checkAndResetRemovedFilters();
      }
    });
    const boundTouchMove = (e) => this.onThumbTouchMove(e);
    const boundTouchEnd = () => this.onThumbTouchEnd();
    const boundTouchCancel = () => this.onThumbTouchCancel();
    document.addEventListener("mouseup", () => this.handleDragEnd());
    document.addEventListener("touchend", () => this.handleDragEnd());
    document.addEventListener("touchmove", boundTouchMove, { passive: false });
    document.addEventListener("touchcancel", boundTouchCancel);
    this.__boundTouchMove = boundTouchMove;
    this.__boundTouchEnd = boundTouchEnd;
    this.__boundTouchCancel = boundTouchCancel;
  },
  // Cleanup method to prevent memory leaks
  destroy() {
    if (this._debouncedApplyFilters) {
      clearTimeout(this._debouncedApplyFilters);
      this._debouncedApplyFilters = null;
    }
    this._pendingFilterApplication = false;
    if (this.__boundTouchMove) {
      document.removeEventListener("touchmove", this.__boundTouchMove);
    }
    if (this.__boundTouchEnd) {
      document.removeEventListener("touchend", this.__boundTouchEnd);
    }
    if (this.__boundTouchCancel) {
      document.removeEventListener("touchcancel", this.__boundTouchCancel);
    }
    delete this.__initialTouchX;
    delete this.__initialValue;
    delete this.__trackRect;
    delete this.__containerLeft;
    delete this.__containerWidth;
    delete this.__boundTouchMove;
    delete this.__boundTouchEnd;
    delete this.__boundTouchCancel;
  },
  // Check if diamond filters were removed and reset ranges accordingly
  checkAndResetRemovedFilters() {
    if (this.isInitializing) return;
    const store = Alpine.store("fastSimon");
    if (!store) return;
    if (this.clarityFilter && this.clarityOptions.length > 0) {
      const hasAppliedClarity = this.clarityOptions.some(
        (value) => store.isFilterApplied(this.clarityFilter.param_name, value)
      );
      if (!hasAppliedClarity && this.isClarityActive()) {
        this.clarityRange = [0, Math.max(0, this.clarityOptions.length - 1)];
      }
    }
    if (this.colorFilter && this.colorOptions.length > 0) {
      const hasAppliedColor = this.colorOptions.some(
        (value) => store.isFilterApplied(this.colorFilter.param_name, value)
      );
      if (!hasAppliedColor && this.isColorActive()) {
        this.colorRange = [0, Math.max(0, this.colorOptions.length - 1)];
      }
    }
    if (this.cutFilter && this.cutOptions.length > 0) {
      const hasAppliedCut = this.cutOptions.some(
        (value) => store.isFilterApplied(this.cutFilter.param_name, value)
      );
      if (!hasAppliedCut && this.isCutActive()) {
        this.cutRange = [0, Math.max(0, this.cutOptions.length - 1)];
      }
    }
    if (this.fluorescenceFilter && this.fluorescenceOptions.length > 0) {
      const hasAppliedFluorescence = this.fluorescenceOptions.some((normalizedValue) => {
        const originalValue = this.fluorescenceFilter.values.find((v) => {
          const normalizedValueFromFilter = String(v.value).toLowerCase();
          const valueMap = {
            "non": "None",
            "none": "None",
            "fnt": "Faint",
            "faint": "Faint",
            "med": "Medium",
            "medium": "Medium",
            "stg": "Strong",
            "strong": "Strong",
            "vst": "Very Strong",
            "very strong": "Very Strong"
          };
          const mappedValue = valueMap[normalizedValueFromFilter] || v.label || v.value;
          return mappedValue === normalizedValue;
        });
        return originalValue && store.isFilterApplied(this.fluorescenceFilter.param_name, originalValue.value);
      });
      if (!hasAppliedFluorescence && this.isFluorescenceActive()) {
        this.fluorescenceRange = [0, Math.max(0, this.fluorescenceOptions.length - 1)];
      }
    }
    if (this.polishFilter && this.polishOptions.length > 0) {
      const hasAppliedPolish = this.polishOptions.some(
        (value) => store.isFilterApplied(this.polishFilter.param_name, value)
      );
      if (!hasAppliedPolish && this.isPolishActive()) {
        this.polishRange = [0, Math.max(0, this.polishOptions.length - 1)];
      }
    }
    if (this.symmetryFilter && this.symmetryOptions.length > 0) {
      const hasAppliedSymmetry = this.symmetryOptions.some((normalizedValue) => {
        const originalValue = this.symmetryFilter.values.find((v) => {
          const originalVal = String(v.value);
          const valueMap = {
            "poor": "Poor",
            "Poor": "Poor",
            "P": "Poor",
            "fair": "Fair",
            "Fair": "Fair",
            "F": "Fair",
            "good": "Good",
            "Good": "Good",
            "G": "Good",
            "very good": "Very Good",
            "Very Good": "Very Good",
            "VG": "Very Good",
            "excellent": "Excellent",
            "Excellent": "Excellent",
            "EX": "Excellent"
          };
          const mappedValue = valueMap[originalVal] || originalVal;
          return mappedValue === normalizedValue;
        });
        return originalValue && store.isFilterApplied(this.symmetryFilter.param_name, originalValue.value);
      });
      if (!hasAppliedSymmetry && this.isSymmetryActive()) {
        this.symmetryRange = [0, Math.max(0, this.symmetryOptions.length - 1)];
      }
    }
  },
  initializeFilters() {
    const clarity = this.clarityOptions;
    const color = this.colorOptions;
    const cut = this.cutOptions;
    const fluorescence = this.fluorescenceOptions;
    const polish = this.polishOptions;
    const symmetry = this.symmetryOptions;
    if (clarity.length > 0) {
      this.initializeClarityFromURL();
      this.clarityInitialized = true;
    }
    if (color.length > 0) {
      this.initializeColorFromURL();
      this.colorInitialized = true;
    }
    if (cut.length > 0) {
      this.initializeCutFromURL();
      this.cutInitialized = true;
    }
    if (fluorescence.length > 0) {
      this.initializeFluorescenceFromURL();
      this.fluorescenceInitialized = true;
    }
    if (polish.length > 0) {
      this.initializePolishFromURL();
      this.polishInitialized = true;
    }
    if (symmetry.length > 0) {
      this.initializeSymmetryFromURL();
      this.symmetryInitialized = true;
    }
    this.checkInitializationComplete();
  },
  handleDragEnd() {
    if (this.isDragging) {
      this.isDragging = false;
      const wasFiltering = this.dragType !== "";
      this.dragType = "";
      if (wasFiltering && !this.isInitializing) {
        setTimeout(() => {
          this.applyFiltersToFastSimon();
        }, 0);
      }
    }
  },
  checkInitializationComplete() {
    const hasClarity = this.clarityOptions.length > 0;
    const hasColor = this.colorOptions.length > 0;
    const hasCut = this.cutOptions.length > 0;
    const hasFluorescence = this.fluorescenceOptions.length > 0;
    const hasPolish = this.polishOptions.length > 0;
    const hasSymmetry = this.symmetryOptions.length > 0;
    const allInitialized = (!hasClarity || this.clarityInitialized) && (!hasColor || this.colorInitialized) && (!hasCut || this.cutInitialized) && (!hasFluorescence || this.fluorescenceInitialized) && (!hasPolish || this.polishInitialized) && (!hasSymmetry || this.symmetryInitialized);
    if (allInitialized && this.isInitializing) {
      this.isInitializing = false;
      this.debouncedApplyFilters();
    }
  },
  applyFiltersToFastSimon() {
    var _a, _b, _c, _d, _e, _f;
    if (this.isInitializing) {
      return;
    }
    if (this._pendingFilterApplication) {
      return;
    }
    const store = Alpine.store("fastSimon");
    if (!store) {
      console.error("[DiamondStepFilters] FastSimon store not available!");
      return;
    }
    this._pendingFilterApplication = true;
    const shouldUsePendingFilters = store.shouldUsePendingFilters();
    const removeFilter = shouldUsePendingFilters ? (name) => store.removeFilter(name) : (name) => store.removeFilter(name);
    const addFilter = shouldUsePendingFilters ? (name, value) => store.addFilter(name, value) : (name, value) => store.addFilter(name, value);
    const filtersToRemove = [
      (_a = this.clarityFilter) == null ? void 0 : _a.param_name,
      (_b = this.colorFilter) == null ? void 0 : _b.param_name,
      (_c = this.cutFilter) == null ? void 0 : _c.param_name,
      (_d = this.fluorescenceFilter) == null ? void 0 : _d.param_name,
      (_e = this.polishFilter) == null ? void 0 : _e.param_name,
      (_f = this.symmetryFilter) == null ? void 0 : _f.param_name
    ].filter(Boolean);
    filtersToRemove.forEach((paramName) => {
      removeFilter(paramName);
    });
    const filtersToAdd = [];
    if (this.isClarityActive()) {
      const selectedClarity = this.getSelectedClarity();
      if (selectedClarity.length > 0) {
        filtersToAdd.push({
          paramName: this.clarityFilter.param_name,
          values: selectedClarity
        });
      }
    }
    if (this.isColorActive()) {
      const selectedColor = this.getSelectedColor();
      if (selectedColor.length > 0) {
        filtersToAdd.push({
          paramName: this.colorFilter.param_name,
          values: selectedColor
        });
      }
    }
    if (this.isCutActive()) {
      const selectedCut = this.getSelectedCut();
      if (selectedCut.length > 0) {
        filtersToAdd.push({
          paramName: this.cutFilter.param_name,
          values: selectedCut
        });
      }
    }
    if (this.isFluorescenceActive()) {
      const selectedFluorescence = this.getSelectedFluorescence();
      if (selectedFluorescence.length > 0) {
        filtersToAdd.push({
          paramName: this.fluorescenceFilter.param_name,
          values: selectedFluorescence
        });
      }
    }
    if (this.isPolishActive()) {
      const selectedPolish = this.getSelectedPolish();
      if (selectedPolish.length > 0) {
        filtersToAdd.push({
          paramName: this.polishFilter.param_name,
          values: selectedPolish
        });
      }
    }
    if (this.isSymmetryActive()) {
      const selectedSymmetry = this.getSelectedSymmetry();
      if (selectedSymmetry.length > 0) {
        filtersToAdd.push({
          paramName: this.symmetryFilter.param_name,
          values: selectedSymmetry
        });
      }
    }
    filtersToAdd.forEach((filter) => {
      filter.values.forEach((value) => {
        addFilter(filter.paramName, value);
      });
    });
    this._pendingFilterApplication = false;
    this._lastFilterApplicationTime = Date.now();
    if (!shouldUsePendingFilters) {
      store.updateURL();
      if (store._debouncedFetch) {
        store._debouncedFetch();
      } else {
        store.fetchProducts(
          store.collectionId,
          store.productsPerPage,
          1,
          false
        );
      }
    }
  },
  // Helper methods to get selected values based on range
  getSelectedClarity() {
    if (this.clarityOptions.length === 0) return [];
    return this.clarityOptions.slice(this.clarityRange[0], this.clarityRange[1] + 1);
  },
  getSelectedColor() {
    if (this.colorOptions.length === 0) return [];
    return this.colorOptions.slice(this.colorRange[0], this.colorRange[1] + 1);
  },
  getSelectedCut() {
    if (this.cutOptions.length === 0) return [];
    return this.cutOptions.slice(this.cutRange[0], this.cutRange[1] + 1);
  },
  getSelectedFluorescence() {
    if (this.fluorescenceOptions.length === 0) return [];
    return this.fluorescenceOptions.slice(this.fluorescenceRange[0], this.fluorescenceRange[1] + 1);
  },
  getSelectedPolish() {
    if (this.polishOptions.length === 0) return [];
    return this.polishOptions.slice(this.polishRange[0], this.polishRange[1] + 1);
  },
  getSelectedSymmetry() {
    if (this.symmetryOptions.length === 0) return [];
    return this.symmetryOptions.slice(this.symmetryRange[0], this.symmetryRange[1] + 1);
  },
  // Check if filters are active (not showing full range)
  isClarityActive() {
    return this.clarityOptions.length > 0 && (this.clarityRange[0] > 0 || this.clarityRange[1] < this.clarityOptions.length - 1);
  },
  isColorActive() {
    return this.colorOptions.length > 0 && (this.colorRange[0] > 0 || this.colorRange[1] < this.colorOptions.length - 1);
  },
  isCutActive() {
    return this.cutOptions.length > 0 && (this.cutRange[0] > 0 || this.cutRange[1] < this.cutOptions.length - 1);
  },
  isFluorescenceActive() {
    return this.fluorescenceOptions.length > 0 && (this.fluorescenceRange[0] > 0 || this.fluorescenceRange[1] < this.fluorescenceOptions.length - 1);
  },
  isPolishActive() {
    return this.polishOptions.length > 0 && (this.polishRange[0] > 0 || this.polishRange[1] < this.polishOptions.length - 1);
  },
  isSymmetryActive() {
    return this.symmetryOptions.length > 0 && (this.symmetryRange[0] > 0 || this.symmetryRange[1] < this.symmetryOptions.length - 1);
  },
  initializeClarityFromURL() {
    if (this.clarityOptions.length === 0 || !this.clarityFilter) {
      this.clarityRange = [0, 0];
      return;
    }
    const store = Alpine.store("fastSimon");
    if (!store) return;
    const appliedIndices = [];
    this.clarityOptions.forEach((value, index) => {
      if (store.isFilterApplied(this.clarityFilter.param_name, value)) {
        appliedIndices.push(index);
      }
    });
    if (appliedIndices.length > 0) {
      const minIndex = Math.min(...appliedIndices);
      const maxIndex = Math.max(...appliedIndices);
      this.clarityRange = [minIndex, maxIndex];
    } else {
      this.clarityRange = [0, Math.max(0, this.clarityOptions.length - 1)];
    }
  },
  initializeColorFromURL() {
    if (this.colorOptions.length === 0 || !this.colorFilter) {
      this.colorRange = [0, 0];
      return;
    }
    const store = Alpine.store("fastSimon");
    if (!store) return;
    const appliedIndices = [];
    this.colorOptions.forEach((value, index) => {
      if (store.isFilterApplied(this.colorFilter.param_name, value)) {
        appliedIndices.push(index);
      }
    });
    if (appliedIndices.length > 0) {
      const minIndex = Math.min(...appliedIndices);
      const maxIndex = Math.max(...appliedIndices);
      this.colorRange = [minIndex, maxIndex];
    } else {
      this.colorRange = [0, Math.max(0, this.colorOptions.length - 1)];
    }
  },
  initializeCutFromURL() {
    if (this.cutOptions.length === 0 || !this.cutFilter) {
      this.cutRange = [0, 0];
      return;
    }
    const store = Alpine.store("fastSimon");
    if (!store) return;
    const appliedIndices = [];
    this.cutOptions.forEach((value, index) => {
      if (store.isFilterApplied(this.cutFilter.param_name, value)) {
        appliedIndices.push(index);
      }
    });
    if (appliedIndices.length > 0) {
      const minIndex = Math.min(...appliedIndices);
      const maxIndex = Math.max(...appliedIndices);
      this.cutRange = [minIndex, maxIndex];
    } else {
      this.cutRange = [0, Math.max(0, this.cutOptions.length - 1)];
    }
  },
  initializeFluorescenceFromURL() {
    if (this.fluorescenceOptions.length === 0 || !this.fluorescenceFilter) {
      this.fluorescenceRange = [0, 0];
      return;
    }
    const store = Alpine.store("fastSimon");
    if (!store) return;
    const appliedIndices = [];
    this.fluorescenceOptions.forEach((normalizedValue, index) => {
      const originalValue = this.fluorescenceFilter.values.find((v) => {
        const normalizedValueFromFilter = String(v.value).toLowerCase();
        const valueMap = {
          "non": "None",
          "none": "None",
          "fnt": "Faint",
          "faint": "Faint",
          "med": "Medium",
          "medium": "Medium",
          "stg": "Strong",
          "strong": "Strong",
          "vst": "Very Strong",
          "very strong": "Very Strong"
        };
        const mappedValue = valueMap[normalizedValueFromFilter] || v.label || v.value;
        return mappedValue === normalizedValue;
      });
      if (originalValue && store.isFilterApplied(this.fluorescenceFilter.param_name, originalValue.value)) {
        appliedIndices.push(index);
      }
    });
    if (appliedIndices.length > 0) {
      const minIndex = Math.min(...appliedIndices);
      const maxIndex = Math.max(...appliedIndices);
      this.fluorescenceRange = [minIndex, maxIndex];
    } else {
      this.fluorescenceRange = [0, Math.max(0, this.fluorescenceOptions.length - 1)];
    }
  },
  initializePolishFromURL() {
    if (this.polishOptions.length === 0 || !this.polishFilter) {
      this.polishRange = [0, 0];
      return;
    }
    const store = Alpine.store("fastSimon");
    if (!store) return;
    const appliedIndices = [];
    this.polishOptions.forEach((value, index) => {
      if (store.isFilterApplied(this.polishFilter.param_name, value)) {
        appliedIndices.push(index);
      }
    });
    if (appliedIndices.length > 0) {
      const minIndex = Math.min(...appliedIndices);
      const maxIndex = Math.max(...appliedIndices);
      this.polishRange = [minIndex, maxIndex];
    } else {
      this.polishRange = [0, Math.max(0, this.polishOptions.length - 1)];
    }
  },
  initializeSymmetryFromURL() {
    if (this.symmetryOptions.length === 0 || !this.symmetryFilter) {
      this.symmetryRange = [0, 0];
      return;
    }
    const store = Alpine.store("fastSimon");
    if (!store) return;
    const appliedIndices = [];
    this.symmetryOptions.forEach((normalizedValue, index) => {
      const originalValue = this.symmetryFilter.values.find((v) => {
        const originalVal = String(v.value);
        const valueMap = {
          "poor": "Poor",
          "Poor": "Poor",
          "P": "Poor",
          "fair": "Fair",
          "Fair": "Fair",
          "F": "Fair",
          "good": "Good",
          "Good": "Good",
          "G": "Good",
          "very good": "Very Good",
          "Very Good": "Very Good",
          "VG": "Very Good",
          "excellent": "Excellent",
          "Excellent": "Excellent",
          "EX": "Excellent"
        };
        const mappedValue = valueMap[originalVal] || originalVal;
        return mappedValue === normalizedValue;
      });
      if (originalValue && store.isFilterApplied(this.symmetryFilter.param_name, originalValue.value)) {
        appliedIndices.push(index);
      }
    });
    if (appliedIndices.length > 0) {
      const minIndex = Math.min(...appliedIndices);
      const maxIndex = Math.max(...appliedIndices);
      this.symmetryRange = [minIndex, maxIndex];
    } else {
      this.symmetryRange = [0, Math.max(0, this.symmetryOptions.length - 1)];
    }
  }
});
const API_ENDPOINT = `${DIAMOND_API_URL}/api/validate-stock`;
const TIMEOUT_DURATION = 1e4;
const NOTIFICATION_DURATION = 5e3;
const DIAMOND_VENDORS = ["nivoda", "dharam", "rapnet", "vdb"];
const DiamondStatus = () => ({
  // Alpine.js reactive state
  isNormal: false,
  isError: false,
  isInStock: true,
  isOutOfStock: false,
  isLoading: false,
  isPriceChanged: false,
  isDisabled: false,
  timeoutMessage: "",
  diamondVendors: DIAMOND_VENDORS,
  // Global errors object for Alpine.js reactivity
  errors: {},
  // Store supplier API response for UI reactivity
  diamondValidationResults: [],
  outOfStockDiamonds: [],
  priceChangedDiamonds: [],
  disabledDiamonds: [],
  // Affected diamond info for UI display
  outOfStockItems: [],
  priceChangedItems: [],
  disabledItems: [],
  // Persistent validation state to prevent bypassing validation
  _hasValidationErrors: false,
  _lastValidationTime: 0,
  _validationTimeout: 5 * 60 * 1e3,
  // 5 minutes timeout for validation results
  // Track successful validation with only price changes
  _hasSuccessfulPriceChangeValidation: false,
  _priceChangeValidationTime: 0,
  // Private helper methods
  _validateDiamondItem(item) {
    return typeof item.product_id !== "undefined" && typeof item.vendor !== "undefined" && typeof item.price !== "undefined" && typeof item.sku !== "undefined";
  },
  _extractDiamondItems(cart) {
    const diamondItems = [];
    let hasErrors = false;
    cart.items.forEach((item) => {
      if (this.diamondVendors.includes(item.vendor)) {
        if (!this._validateDiamondItem(item)) {
          hasErrors = true;
          this.errors[`diamond_item_${item.product_id || "unknown"}`] = "Missing required diamond item fields (id, vendor, price, or sku).";
        } else {
          diamondItems.push({
            product_id: item.product_id,
            vendor: item.vendor.toLowerCase(),
            price: item.price / 100,
            sku: item.sku
          });
        }
      }
    });
    return { items: diamondItems, hasErrors };
  },
  async _fetchCartData() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    if (!response.ok) {
      throw new Error(`Failed to fetch cart data: ${response.status}`);
    }
    return response.json();
  },
  async _validateDiamondStock(diamondItems) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), TIMEOUT_DURATION);
    try {
      const response = await fetch(API_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ items: diamondItems }),
        signal: controller.signal
      });
      clearTimeout(timeoutId);
      if (!response.ok) {
        if (response.status >= 500 && response.status < 600) {
          throw new Error("server_error");
        }
        throw new Error(
          `Diamond stock validation failed with status: ${response.status}`
        );
      }
      return await response.json();
    } catch (error) {
      clearTimeout(timeoutId);
      if (error.name === "AbortError") {
        throw new Error("timeout");
      }
      if (error.message.includes("Failed to fetch") || error.message.includes("NetworkError") || error.message.includes("TypeError")) {
        throw new Error("server_error");
      }
      throw error;
    }
  },
  _processValidationResults(validationResults) {
    this.diamondValidationResults = validationResults;
    this.outOfStockDiamonds = [];
    this.priceChangedDiamonds = [];
    this.disabledDiamonds = [];
    validationResults.forEach((item) => {
      if (item.additionalInfo) {
        if (item.additionalInfo.stock_change === true || item.isInStock === false) {
          this.outOfStockDiamonds.push(item);
        }
        if (item.additionalInfo.price_change === true) {
          this.priceChangedDiamonds.push(item);
        }
        if (item.additionalInfo.product_disabled === true) {
          this.disabledDiamonds.push(item);
        }
      } else if (item.isInStock === false) {
        this.outOfStockDiamonds.push(item);
      }
    });
  },
  _showNotification(property, duration = NOTIFICATION_DURATION) {
    this[property] = true;
    setTimeout(() => {
      this[property] = false;
    }, duration);
  },
  _handleSuccessfulValidation(event) {
    this.isNormal = true;
    this.isLoading = false;
    document.dispatchEvent(new CustomEvent("la:dn:checkout:initiate"));
    try {
      event.target.submit();
    } catch (submitError) {
    }
    window.location.href = "/checkout";
  },
  _handleTimeout() {
    this.isLoading = false;
    this.timeoutMessage = "timeout";
    this.isNormal = true;
    window.location.href = "/checkout";
  },
  _handleOutOfStockScenario() {
    this._showNotification("isOutOfStock");
    this.isLoading = false;
  },
  _handlePriceChangedScenario() {
    this.$store.cart.updateCart();
    this._showNotification("isPriceChanged");
    this.isNormal = true;
    this.isLoading = false;
  },
  _handleDisabledScenario() {
    this._showNotification("isDisabled");
    this.isLoading = false;
  },
  _isAllItemsValid(validationResults) {
    return validationResults.every(
      (item) => item.additionalInfo && item.additionalInfo.price_change === false && item.additionalInfo.stock_change === false
    );
  },
  _getAffectedDiamondInfo(cart) {
    const outOfStockItems = [];
    const priceChangedItems = [];
    const disabledItems = [];
    this.outOfStockDiamonds.forEach((validationResult) => {
      const cartItem = cart.items.find(
        (item) => item.product_id === validationResult.productId
      );
      if (cartItem) {
        const itemName = cartItem.product_title || `Product ${cartItem.product_id}`;
        const message = validationResult.message || "This item is out of stock";
        outOfStockItems.push({ name: itemName, message });
      }
    });
    this.priceChangedDiamonds.forEach((validationResult) => {
      const cartItem = cart.items.find(
        (item) => item.product_id === validationResult.productId
      );
      if (cartItem) {
        const itemName = cartItem.product_title || `Product ${cartItem.product_id}`;
        const message = validationResult.message || "Price has changed for this item";
        priceChangedItems.push({ name: itemName, message });
      }
    });
    this.disabledDiamonds.forEach((validationResult) => {
      const cartItem = cart.items.find(
        (item) => item.product_id === validationResult.productId
      );
      if (cartItem) {
        const itemName = cartItem.product_title || `Product ${cartItem.product_id}`;
        const message = validationResult.message || "This product has been disabled";
        disabledItems.push({ name: itemName, message });
      }
    });
    return { outOfStockItems, priceChangedItems, disabledItems };
  },
  _setValidationErrors() {
    this._hasValidationErrors = true;
    this._lastValidationTime = Date.now();
  },
  _clearValidationErrors() {
    this._hasValidationErrors = false;
    this._lastValidationTime = 0;
    this.isPriceChanged = false;
    this._clearSuccessfulPriceChangeValidation();
  },
  _hasRecentValidationErrors() {
    if (!this._hasValidationErrors) return false;
    const timeSinceValidation = Date.now() - this._lastValidationTime;
    return timeSinceValidation < this._validationTimeout;
  },
  _restoreValidationState() {
    if (this._hasRecentValidationErrors()) {
      if (this.outOfStockDiamonds.length > 0) {
        this._handleOutOfStockScenario();
      } else if (this.disabledDiamonds.length > 0) {
        this._handleDisabledScenario();
      }
    }
  },
  _setSuccessfulPriceChangeValidation() {
    this._hasSuccessfulPriceChangeValidation = true;
    this._priceChangeValidationTime = Date.now();
  },
  _clearSuccessfulPriceChangeValidation() {
    this._hasSuccessfulPriceChangeValidation = false;
    this._priceChangeValidationTime = 0;
  },
  _hasRecentSuccessfulPriceChangeValidation() {
    if (!this._hasSuccessfulPriceChangeValidation) return false;
    const timeSinceValidation = Date.now() - this._priceChangeValidationTime;
    return timeSinceValidation < this._validationTimeout;
  },
  // Main public method
  async handleSubmit(event) {
    event.preventDefault();
    this.isLoading = true;
    this.timeoutMessage = "";
    this.errors = {};
    if (this._hasRecentValidationErrors()) {
      this._restoreValidationState();
      this.isLoading = false;
      return;
    }
    if (this._hasRecentSuccessfulPriceChangeValidation()) {
      this._handleSuccessfulValidation(event);
      return;
    }
    try {
      const cart = await this._fetchCartData();
      const { items: diamondItems, hasErrors } = this._extractDiamondItems(cart);
      if (hasErrors) {
        this.isError = true;
        this.isLoading = false;
        return;
      }
      if (diamondItems.length === 0) {
        this._clearValidationErrors();
        this._handleSuccessfulValidation(event);
        return;
      }
      const validationResults = await this._validateDiamondStock(diamondItems);
      this._processValidationResults(validationResults);
      const { outOfStockItems, priceChangedItems, disabledItems } = this._getAffectedDiamondInfo(cart);
      this.outOfStockItems = outOfStockItems;
      this.priceChangedItems = priceChangedItems;
      this.disabledItems = disabledItems;
      if (this.outOfStockDiamonds.length > 0) {
        this._setValidationErrors();
        this._handleOutOfStockScenario();
        return;
      }
      if (this.disabledDiamonds.length > 0) {
        this._setValidationErrors();
        this._handleDisabledScenario();
        return;
      }
      if (this.priceChangedDiamonds.length > 0) {
        this._setSuccessfulPriceChangeValidation();
        this._handlePriceChangedScenario();
        return;
      }
      if (this._isAllItemsValid(validationResults)) {
        this._clearValidationErrors();
        this._handleSuccessfulValidation(event);
      } else {
        this.isLoading = false;
      }
    } catch (error) {
      this.isLoading = false;
      if (error.message === "timeout") {
        this._handleTimeout();
      } else if (error.message === "server_error" || error.message === "server_down") {
        if (this._hasRecentValidationErrors()) {
          this._restoreValidationState();
        } else {
          this._handleSuccessfulValidation(event);
        }
      } else {
        console.error("Error in diamond validation:", error);
        this.isError = true;
      }
    }
  }
});
const ColorCounter = (product) => ({
  product,
  materialCount: 0,
  init() {
    this.materialCount = this.calculateMaterialCount();
  },
  isValidMaterial(material) {
    const materialStr = String(material).trim();
    if (materialStr.startsWith("#")) return false;
    if (materialStr.includes("http")) return false;
    if (materialStr.includes(".jpg") || materialStr.includes(".png") || materialStr.includes(".webp")) return false;
    if (materialStr.includes("cdn.shopify.com")) return false;
    if (materialStr.includes("gid://")) return false;
    if (materialStr.length < 3) return false;
    return true;
  },
  calculateMaterialCount() {
    let materialCount = 0;
    if (this.product.options_with_values) {
      const colorOption = this.product.options_with_values.find((option) => {
        const optionName = option.name.toLowerCase();
        return optionName === "color" || optionName === "colour";
      });
      if (colorOption) {
        materialCount = colorOption.values.length;
      } else {
        if (this.product.variants && this.product.variants.length > 0) {
          const materialsArray = [];
          this.product.variants.forEach((variant) => {
            if (variant.options && Array.isArray(variant.options)) {
              variant.options.forEach((option) => {
                const optionLower = String(option).toLowerCase();
                const optionStr = String(option);
                let isMaterial = false;
                let isFiltered = false;
                if (optionLower.includes("gold") || optionLower.includes("platinum") || optionLower.includes("silver")) {
                  isMaterial = true;
                }
                if (optionStr.includes("#") || optionStr.includes("http") || optionStr.includes(".jpg") || optionStr.includes(".png") || optionStr.includes("cdn.shopify.com") || optionStr.includes("gid://")) {
                  isFiltered = true;
                }
                if (optionStr.length < 3) {
                  isFiltered = true;
                }
                if (isMaterial && !isFiltered) {
                  if (!materialsArray.includes(optionStr)) {
                    materialsArray.push(optionStr);
                  }
                }
              });
            }
          });
          materialCount = materialsArray.length;
        }
      }
    } else if (this.product.options && Array.isArray(this.product.options)) {
      const colorOption = this.product.options.find((option) => {
        const optionName = option.name.toLowerCase();
        return optionName === "color" || optionName === "colour";
      });
      const materialOption = this.product.options.find((option) => {
        const optionName = option.name.toLowerCase();
        return optionName === "material" || optionName.includes("material");
      });
      if (colorOption) {
        materialCount = colorOption.values.length;
      } else if (materialOption) {
        materialCount = materialOption.values.length;
        if (materialCount === 1) {
          const materialsFromVariants = [];
          this.product.variants.forEach((variant) => {
            if (variant.options && Array.isArray(variant.options)) {
              variant.options.forEach((option) => {
                const optionStr = String(option);
                const optionLower = optionStr.toLowerCase();
                if (optionLower.includes("gold") || optionLower.includes("platinum") || optionLower.includes("silver")) {
                  if (!materialsFromVariants.includes(optionStr) && optionStr.length > 2) {
                    materialsFromVariants.push(optionStr);
                  }
                }
              });
            }
          });
          if (materialsFromVariants.length > 1) {
            materialCount = materialsFromVariants.length;
          } else {
            materialCount = 1;
          }
        }
      } else {
        const materialsFromVariants = [];
        this.product.variants.slice(0, 10).forEach((variant) => {
          if (variant.options && Array.isArray(variant.options)) {
            variant.options.forEach((option) => {
              const optionStr = String(option);
              const optionLower = optionStr.toLowerCase();
              if (optionLower.includes("gold") || optionLower.includes("platinum") || optionLower.includes("silver")) {
                if (!materialsFromVariants.includes(optionStr) && optionStr.length > 2) {
                  materialsFromVariants.push(optionStr);
                }
              }
            });
          }
        });
        if (materialsFromVariants.length > 1) {
          materialCount = materialsFromVariants.length;
        } else {
          materialCount = 1;
        }
      }
    } else {
      materialCount = 1;
    }
    return materialCount;
  },
  getDisplayText() {
    const variantsCount = this.product.variants.length;
    return variantsCount > 1 ? `+${variantsCount - 1} Variants` : "";
  },
  shouldShow() {
    return this.product.variants.length > 1;
  }
});
const DiamondViewMode = () => ({
  initViewMode() {
    this.loadGridViewState();
    Alpine.effect(() => {
      Alpine.store("main").isGrid;
      if (this.isDiamondCollection()) {
        this.saveGridViewState();
      }
    });
  },
  isDiamondCollection() {
    const pageType = document.body.dataset.pageType;
    const collectionTemplate = document.body.dataset.collectionTemplate;
    const collectionHandle = document.body.dataset.collectionHandle;
    return pageType === "collection" && (collectionTemplate === "diamond" || collectionHandle === "diamonds");
  },
  loadGridViewState() {
    if (this.isDiamondCollection()) {
      try {
        const savedState = localStorage.getItem("diamond-plp-grid-view");
        if (savedState !== null) {
          Alpine.store("main").isGrid = JSON.parse(savedState);
        }
      } catch (error) {
        console.warn("Failed to load diamond PLP grid view state:", error);
      }
    }
  },
  saveGridViewState() {
    if (this.isDiamondCollection()) {
      try {
        localStorage.setItem("diamond-plp-grid-view", JSON.stringify(Alpine.store("main").isGrid));
      } catch (error) {
        console.warn("Failed to save diamond PLP grid view state:", error);
      }
    }
  }
});
const CountdownTimer = (targetDateString = "", isInfinite = false, remainingChunk = {
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0
}) => ({
  targetDateString,
  isLoaded: false,
  isFinished: false,
  isInfinite,
  remainingChunk,
  init() {
    let target = new Date(this.targetDateString);
    const now = /* @__PURE__ */ new Date();
    let remainingTime = Number(target) - Number(now);
    if (this.isInfinite) {
      while (target < now) {
        target = new Date(target.setDate(target.getDate() + 14));
        remainingTime = Number(target) - Number(now);
      }
    }
    if (remainingTime <= 0) {
      this.isFinished = true;
      this.isLoaded = true;
      this.remainingChunk = {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      };
      return;
    }
    this.isLoaded = true;
    var timerId = setInterval(() => {
      const now2 = /* @__PURE__ */ new Date();
      const remainingTime2 = Number(target) - Number(now2);
      if (remainingTime2 <= 0) {
        clearInterval(timerId);
        this.isFinished = true;
      } else {
        this.remainingChunk = {
          days: Math.floor(remainingTime2 / (1e3 * 60 * 60 * 24)),
          hours: Math.floor(remainingTime2 / (1e3 * 60 * 60) % 24),
          minutes: Math.floor(remainingTime2 / 1e3 / 60 % 60),
          seconds: Math.floor(remainingTime2 / 1e3 % 60)
        };
      }
    }, 1e3);
  }
});
const ReadMore = (options = {}) => ({
  expanded: false,
  contentHeight: 0,
  minContentHeight: options.minContentHeight || 100,
  init() {
    this.$nextTick(() => {
      this.contentHeight = this.$refs.content.scrollHeight;
    });
  },
  toggleReadMore() {
    this.expanded = !this.expanded;
  },
  isExpandedAndContentLong() {
    return this.expanded && this.contentHeight > this.minContentHeight;
  },
  isNotExpandedAndContentLong() {
    return !this.expanded && this.contentHeight > this.minContentHeight;
  }
});
document.addEventListener("DOMContentLoaded", () => {
  if (window.Alpine) {
    Alpine.data("LetsTalkAboutIt", LetsTalkAboutIt);
    Alpine.data("Reservation", ReservationForm);
    Alpine.data("ProductRequestForm", ProductRequestForm);
    Alpine.data("DiamondStepFilters", DiamondStepFilters);
    Alpine.data("DiamondStatus", DiamondStatus);
    Alpine.data("ColorCounter", ColorCounter);
    Alpine.data("DiamondViewMode", DiamondViewMode);
    Alpine.data("CountdownTimer", CountdownTimer);
    Alpine.data("ReadMore", ReadMore);
  }
  setTimeout(() => {
    initElevarGtmCustomizations();
  }, 100);
});
